<template>
    <div>
        <div class="chart-container" :id="'chart-container-'+title" style="position: relative; height: 0px; width:">
            <canvas :id="`${title}`"></canvas>
        </div>
        <div v-if="!loaded" class="loader-container">
            <facebook-loader :speed="3" :animate=true :height=130 :width=400></facebook-loader>
        </div>
    </div>
</template>

<script>
import { dataConvertDict } from './ChartData.js'
import { getHeadersWithAccessToken } from '../functions.js'
import ChartClass from '../chart/ChartClass.js'
import axios from '@/services/axios.js'
import { FacebookLoader } from 'vue-content-loader'
export default {
    props: ['endpoint', 'title', 'params', 'storeModule', 'store'],
    data () {
        return {
            chart: {},
            loaded: false
        }
    },
    computed: {
    },
    components: {
        FacebookLoader
    },
    methods: {
        draw (individualStore = undefined) {
            this.loaded = false
            let endpoint = ''
            let title = ''

            // Get the container and set its size to 0px to make room for the loading animation
            var container = document.getElementById('chart-container-' + this.$props.title)
            container.style.height = '0px'

            // Some endpoints need to be adjusted here based on the value of variable in vuex
            let peerEndpoints = ['/performance/workforce/age', '/performance/workforce/hourly_rate', '/performance/workforce/hours_share', '/performance/workforce/work_experience']
            if (this.$store.state.graphFilter.timePeers === 'Peers' && peerEndpoints.includes(this.$props.endpoint)) {
                endpoint = this.$props.endpoint + '_peers'
                title = this.$props.title + '_peers'
            } else {
                endpoint = this.$props.endpoint
                title = this.$props.title
            }
            if (this.$props.endpoint === '/performance/contracts') {
                if (this.$store.state.graphFilter.contractsSwitch === 'Total') {
                    endpoint += '/base'
                } else {
                    endpoint += '/employee'
                    title = this.$props.title + '_employee'
                }
            }

            // Get the ctx and payload for the request
            var ctx = document.getElementById(`${this.$props.title}`).getContext('2d')
            var payload = {
                'format': 'doa',
                'store_id': this.$props.endpoint !== '/budget/budget/summary' ? this.$store.getters['graphFilter/getStoreIds'] : this.$store.getters['budget/getStoreIds'],
                'year': this.$props.endpoint !== '/budget/budget/summary' ? null : this.$store.getters['budget/getYear'],
                'week': this.$props.endpoint !== '/budget/budget/summary' ? null : this.$store.getters['budget/getWeek'],
                'period_type': this.$store.getters['graphFilter/getPeriod'],
                'period_amount': this.$store.getters['graphFilter/getNumberOfPeriods'],
                'days_back': 0
            }

            if (this.$props.endpoint === '/performance/contracts') {
                payload['store_id'] = this.$store.getters['graphFilter/getZoomedinStores']
            }

            // If store is passed instead in vuex, set it here since props are too slow (apparently)
            if (individualStore !== undefined) {
                payload['store_id'] = [individualStore]
            } else if (this.$props.store !== undefined) {
                payload['store_id'] = [this.$props.store]
            }

            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at' + endpoint, payload, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    // Get data for the chart
                    var chartData = {}
                    if (title === 'employeehours' || title === 'productivitystoredetail') {
                        let data = {}
                        data[this.$store.state.graphFilter.productivitySwitch] = response.data.data[this.$store.state.graphFilter.productivitySwitch]
                        data['x_label'] = response.data.data['x_label']
                        chartData = dataConvertDict[title](response.data.data, this.$store.state.graphFilter.productivitySwitch)
                    } else {
                        chartData = dataConvertDict[title](response.data.data)
                    }

                    // Check if chart has already been drawn, if so delete
                    // eslint-disable-next-line
                    if (Object.keys(this.chart).length > 0) {
                        this.chart.delete()
                    }

                    // Generate the chart
                    this.chart = new ChartClass(ctx, chartData['labels'], chartData['data'], chartData['scales'], chartData['type'], chartData['lineToday'])
                    this.loaded = true
                    this.$emit('loaded')

                    // Get the container and increase its height from 0px to 350/450px
                    let container = document.getElementById('chart-container-' + this.$props.title)

                    // Some charts need a different height
                    if (title === 'budgetsummary' || title === 'productivitystoredetail') {
                        try {
                            container.style.height = '350px'
                        } catch {
                            // Sometimes template is not rendered so this will throw an error
                        }
                    } else {
                        try {
                            container.style.height = '450px'
                        } catch {
                            // Sometimes template is not rendered so this will throw an error
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    mounted () {
        this.draw()
    }
}
</script>
